export const formatDate = (
  dateInput: string | Date | null | undefined
) => {
  if (!dateInput) return '-';

  let date: Date;

  if (typeof dateInput === 'string') {
    date = new Date(dateInput);
  } else {
    date = dateInput;
  }

  if (isNaN(date.getTime())) return '-';

  return date.toLocaleDateString('pt-BR');
};
